import { formatDistance } from "date-fns";

export function formatDateDistance(date: Date): string {
    return formatDistance(date, new Date(), { addSuffix: true });
}
